import { XCircleIcon } from "@heroicons/react/solid";

const InputField = ({
  placeholder,
  Icon,
  label,
  type,
  onChange,
  onClickClear,
  value,
  onClick,
  onFocus,
  onKeyDown,
}) => {
  return (
    <div>
      <div className="flex font-serif bg-white px-3  rounded-lg space-x-1 items-center  lg:px-2 lg:py-[3px] lg:w-full lg:h-full">
        <Icon className="h-5 w-5 mr-2 lg:h-5 lg:w-10 lg:mr-3 text-primary " />

        <div className="w-full ">
          <div className="flex justify-between">
            <div className="text-sm md:text-sm font-sans font-semibold text-gray-500">
              {label}
            </div>
            {/* {value ? (
              <div>
                <XCircleIcon
                  onClick={onClickClear}
                  className="h-5 w-4 mr-2 cursor-pointer hover:text-primary lg:h-5 lg:w-10 lg:mr-3 text-red-500"
                />
              </div>
            ) : (
              <div></div>
            )} */}
          </div>
          <input
            required
            onKeyDown={onKeyDown}
            onClick={onClick}
            onFocus={onFocus}
            type={type}
            value={value}
            className="border-none focus:outline-none w-full h-full lg:w-full text-xs md:text-sm lg:text-base font-sans text-black"
            placeholder={`${placeholder}`}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};

export default InputField;
